export const defaultColumnsOrder = [
  "Slno",
  "Code",
  "Description",
  "Unit",
  "Stock",
  "Ro Qty",
  "Ord Qty",
  "Remarks",
  "Supplier Modal",
  "Category",
];

// 2. Field Mapping (Header Name to Internal State Key)
export const columnFieldMap = {
  Slno: "sino",
  Code: "code",
  Description: "description",
  Unit: "unit",
  Stock: "stock",
  "Ro Qty": "roQty",
  "Ord Qty": "ordQty",
  Remarks: "remarks",
  "Supplier Modal": "supplierModal",
  Category: "category",
};

// 3. Base Column Configuration Function
export const getBaseColumn = (
  field,
  widthMap,
  renderers,
  locationOptions,
  unitOptions,
  salespersonOptions
) => {
  const baseConfig = {
    field,
    headerName:
      Object.entries(columnFieldMap).find(
        ([, value]) => value === field
      )?.[0] || field,
    width: widthMap?.[field] || 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: false,
  };

  // Numeric fields
  if (["stock", "roQty", "ordQty"].includes(field)) {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderEditableCell(params, field, "number"),
    };
  }

  // Text fields
  if (
    ["code", "description", "remarks", "supplierModal", "category"].includes(
      field
    )
  ) {
    return {
      ...baseConfig,
      renderCell: (params) => renderers.renderEditableCell(params, field),
    };
  }

  if (field === "unit") {
    return {
      ...baseConfig,
      renderCell: (params) =>
        renderers.renderSelectCell(params, "unit", unitOptions),
    };
  }

  return baseConfig;
};

export const calculateRowValues = (item, purchaseData) => {
  return {
    ...item,
  };
};

export const getVatPercent = () => 0;

export const requiredFields = [
  "code",
  "description",
  "unit",
];

export const newItemTemplate = (id, sino, defaultLocation) => ({
  id,
  sino,
  code: "",
  description: "",
  unit: "",
  stock: 0,
  roQty: 0,
  ordQty: 0,
  remarks: "",
  supplierModal: "",
  category: "",
  isIncluded: true,
});

export const defaultColumnPercents = {
  sino: 5,
  code: 10,
  description: 25,
  unit: 8,
  stock: 8,
  roQty: 8,
  ordQty: 8,
  remarks: 12,
  supplierModal: 12,
  category: 10,
};

const screenCode = "PURCHASE_ENQUIRY";

export const purchaseEnquiryConfig = {
  columnFieldMap,
  defaultColumnsOrder,
  getBaseColumn,
  calculateRowValues,
  getVatPercent,
  screenCode,
  defaultColumnPercents,
  requiredFields,
  newItemTemplate,
};

export default purchaseEnquiryConfig;
